import React from 'react'
import Grid from '@material-ui/core/Grid'
import { Field } from 'react-final-form'
import {
  List,
  Filter,
  TextField,
  useListRepository,
  useFilter,
  DatePicker
} from 'elentari'
import abbreviate from 'abbreviate-name'
import { useAbility } from '../Usuarios'
import { getListActions } from '../../lib/crudAuthorization'
import solicitacoesHistoricoRepository from './solicitacoesHistoricoRepository'
import moment from 'moment'
import { BadgeStatus } from '../Solicitacoes/components'
import { parseCpf } from '../../utils/Parse'
import { useLocation } from 'react-router-dom'

const SolicitacoesHistoricoFilter = () => {
  const filter = useFilter({})

  const detailedFilter = () => (
    <Grid container spacing={3}>
      <Grid item xs={6}>
        <Field
          fullWidth
          component={DatePicker}
          label="Data Criação"
          name="createdAt"
        />
      </Grid>
      <Grid item xs={6}>
        <Field
          fullWidth
          component={DatePicker}
          label="Data Término"
          name="dataTermino"
        />
      </Grid>
    </Grid>
  )

  return (
    <Filter
      {...filter}
      detailedFilter={detailedFilter()}
      labels={{
        detailedFilter: 'Busca avançada',
        simpleFilter: 'Busca simples',
        find: 'Buscar',
        clear: 'Limpar'
      }}
    >
      <Grid spacing={3} container>
        <Grid item sm={4} xs={12}>
          <Field
            fullWidth
            name="motorista"
            label="Motorista"
            component={TextField}
          />
        </Grid>
        <Grid item sm={4} xs={12}>
          <Field
            fullWidth
            name="cpf"
            label="CPF Motorista"
            parse={parseCpf}
            component={TextField}
          />
        </Grid>
        <Grid item sm={4} xs={12}>
          <Field fullWidth name="placa" label="Placa" component={TextField} />
        </Grid>
      </Grid>
    </Filter>
  )
}

const SolicitacoesHistorico = props => {
  const [ability] = useAbility()
  const location = useLocation()

  const listHook = useListRepository({
    repository: solicitacoesHistoricoRepository,
    path: 'solicitacoesHistorico',
    defaultSort: 'createdAt DESC'
  })

  const listOptions = {
    defaultOrder: 'createdAt DESC',
    fields: {
      id: {
        label: 'Id'
      },
      motorista: {
        label: 'Motorista',
        format: motorista => (motorista ? abbreviate(motorista.nome) : '-'),
        noOrder: true
      },
      createdAt: {
        label: 'Data Criação',
        format: data => moment(data).format('DD/MM/YYYY HH:mm')
      },
      status: {
        label: 'Status',
        format: (value, solicitacao) => (
          <BadgeStatus
            status={value}
            cenario={solicitacao.cenario}
            fonteLiberacao={solicitacao.fonteLiberacao}
          />
        )
      },
      dataTermino: {
        label: 'Data Término',
        format: data => (data ? moment(data).format('DD/MM/YYYY HH:mm') : '-')
      },
      mercadoria: {
        label: 'Mercadoria',
        format: mercadoria => (mercadoria ? mercadoria.descricao : '-'),
        noOrder: true
      },
      nomeEmbarcador: {
        label: 'Embarcador',
        format: value => (value ? abbreviate(value) : ''),
        noOrder: true
      },
      centroCusto: {
        label: 'Centro de Custo',
        format: centroCusto => (centroCusto ? centroCusto.descricao : '-'),
        noOrder: true
      },
      responsavel: {
        label: 'Responsável',
        format: responsavel => (responsavel ? responsavel.usuario : '-'),
        noOrder: true
      }
    }
  }

  const actions = getListActions(ability, listHook, 'solicitacoesHistorico')

  const onClickRow = item => {
    if (ability.can('update', 'solicitacoes')) {
      props.history.push(`/solicitacoesAnalista/${item.id}`)
    } else {
      props.history.push(`/solicitacoesHistorico/${item.id}`)
    }
  }

  const emptyText = location.search.length
    ? 'Sem Resultados.'
    : 'Informe pelo menos um filtro de busca.'

  return (
    <>
      <SolicitacoesHistoricoFilter />
      <List
        {...props}
        {...listHook}
        {...actions}
        hideDownloadIcon
        stickyHeader
        adjustToScreenHeight
        onClickView={null}
        onClickEdit={null}
        onClickNew={null}
        removeItem={null}
        onClickRow={onClickRow}
        listOptions={listOptions}
        emptyText={emptyText}
      />
    </>
  )
}

export default SolicitacoesHistorico
